// extracted by mini-css-extract-plugin
module.exports = {"btn":"searchBar_btn__uePp1","box":"searchBar_box__1907X"};